<template>
  <div >
    <headers >
        <search class="articles_search"  @searchVal="search_submit"></search>
    </headers>
    <div class="d_main clearfix" :class="JSON.stringify(listData) != '{}' ? 'd_main_s' : ''"  v-if='!rightType'>
      <div class="d_main_left" v-if='JSON.stringify(listData) != "{}"'>
        <div class="d_navigation" :key='index' v-for='(menus_item,index) in categoryList'>
            <div class="d_nav_title" :class="menus_item.categoryId==menusId && menusUpDownType? 'cur' : ''" @click="menusClickFun(menus_item.categoryId,2)">{{menus_item.categoryName}}
              <span :class="menus_item.categoryId==menusId && menusUpDownType? ' up' : 'down'" class="up"></span>
            </div>
            <div v-if="menus_item.categoryId==menusId && menusUpDownType " :class="hotList.length==0 && secondaryMenu.length==0? '' : 'd_unfold'" >
              <div v-if="navHotCur" >
                  <h3 class="d_hot" @click="hotClickFun(menus_item.categoryId,2)">热门问题
                    <span class="up" :class="menus_item.categoryId==hotCurId && hotType==2 && upDownType? ' up' : 'down'"></span>
                  </h3>
                  <ul class="d_hot_list" v-if="menus_item.categoryId==hotCurId && hotType==2 && upDownType">
                      <li :class="$route.params.id==hot_item.id &&hotType==2 ? 'cur' : ''" :key='hot_index' v-for='(hot_item,hot_index) in hotList' @click="detailClick(hot_item.id,2)" >
                        <div v-if='validateTextLength(hot_item.title)>20'><em></em>{{hot_item.title}}</div>
                        <span>{{hot_item.title}}</span></li>
                  </ul>
              </div>
              <div :key='nav_index' v-for='(nav_item,nav_index) in secondaryMenu'>
                  <h3 class="d_hot" @click="navClickFun(nav_item.categoryId,1)">{{nav_item.categoryName}}
                    <span class="up" :class="nav_item.categoryId==navCurId &&hotType==1 && upDownType? ' up' : 'down'"></span>
                  </h3>

                  <ul class="d_hot_list" v-if='nav_item.categoryId==navCurId && hotType==1 && upDownType' >
                      <li :class="$route.params.id==item.id &&hotType==1? 'cur' : ''" :key='index' v-for='(item,index) in navList' @click="detailClick(item.id,1)" >
                        <div v-if='validateTextLength(item.title)>20'><em></em>{{item.title}}</div>
                        <span>{{item.title}}</span>
                        </li>
                  </ul>
              </div>
            </div>
        </div>
      </div>
      <div class="d_main_right" v-if='JSON.stringify(listData) != "{}"'>
        <div class="d_bread">
            <a href="/">首页</a><em>/</em>
            <span v-if="firstCategory">{{firstCategory}}</span><em v-if="firstCategory">/</em>
            <span v-if="secondCategory">{{secondCategory}}</span><em v-if="secondCategory">/</em>
            <span class="bread_title">{{listData.title}}</span>
        </div>
        <div class="d_article_title">
            <h3>{{listData.title}}</h3>
            <p>发布时间: {{listData.updateTime}}</p>
        </div>
        <div class="d_article_main">
          <div class="d_article" v-if="listData.video">
              <video controls="controls" :src="listData.video" width="700" height="350">
              </video>
          </div>
          <div v-html="listData.content" class="d_comment_info">

          </div>
        </div>

      </div>
    </div>
    <div class="d_no_list" v-if='JSON.stringify(listData) == "{}" && rightType'>
        <img src="./../assets/icon-chahua.png" alt="">
        <p>
            本篇内容下线了，请浏览其他内容吧！
        </p>
    </div>
    <footerHtml></footerHtml>
  </div>
</template>

<script>
import headers from '../components/headers.vue'
import search from '../components/search.vue'
import footerHtml from '../components/footer_html.vue'
import {getArticleDetail,getArticleOldDetail,getCategoryList,
  getHotList,
  getArticleList} from '@/axios'
export default {
  name: 'articles',
  components: {
    headers,
    search,
    footerHtml
  },
  data () {
    return {
      navHotCur:true,//判断是否展示热门导航
      menusId:0,//0为获取一级导航，其他为一级导航ID
      navCurId:0,//展开二级导航ID
      hotCurId:0,//展开二级导航热门问题导航id
      detailType:true, //判断是否第一次刷新路由
      hotType:0,//判断二级问题是否热门‘2’热门、 1不是热门
      upDownType:true,
      menusUpDownType:true,
      secondaryMenu:[],
      navList:[],
      hotList:[],
      categoryList:[],
      listData:{},
      rightType:false,
      firstCategory:'',
      secondCategory:''
    }
  },created(){
    let routerCurrent=this.$router.history.current
    if(routerCurrent.name=="hc_articles"){
        this.oldDetailData(routerCurrent.params.id);
    }else if(routerCurrent.name=="articles"){
      this.newDetailData(routerCurrent.params.id);
    }


  },methods:{
        search_submit(data){
          this.$router.push({path:'/hc/search',query: {id:data}})
        },
        validateTextLength (value) {
        // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
          let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
          let mat = value.match(cnReg)
          let length
          if (mat) {
            length = (mat.length + (value.length - mat.length) * 0.5)
            return length
          } else {
            return value.length * 0.5
          }
        },
        //一级目录
       async menusData(id){
          this.categoryList=[];
          const res = await getCategoryList({
              parentId:id
          })
          let _D = res.data;
          if (_D.code == 22000) {
              this.categoryList=_D.result;
          }
        },
        //二级目录
       async categoryListData(id) {
          let route_name = this.$route.name;
          this.secondaryMenu=[];
            const res = await getCategoryList({
              parentId:id
            })
              let _D = res.data;
            if (_D.code == 22000) {
              this.secondaryMenu=_D.result;
            }
        },
        //热门列表
       async hotListData(id) {
          this.hotCurId=id;
             const res = await getHotList({
                categoryId:id
              })
              let _D = res.data;
              if(_D.code == 22000){
                if(_D.result.length==0){
                  this.navHotCur=false;
                }else{
                  this.navHotCur=true;
                  this.hotList=res.data.result;
                }
              }
        },
        //二级目录对应列表
       async articleListData(id) {
          this.navList=[];
          const res = await getArticleList({
                categoryId:id
          })
          let _D = res;
          if(_D.code == 22000){
              this.navList=res.result;
          }
        },
        menusClickFun(id,type){
          if(this.menusUpDownType && this.menusId==id && type==2){
              this.menusUpDownType=false;
          }else if(!this.menusUpDownType && this.menusId==id && type==2){
              this.menusUpDownType=true;
              this.hotList=[];
              this.secondaryMenu=[];
              this.categoryListData(id);
              this.hotListData(id);
          }else{
              this.hotList=[];
              this.secondaryMenu=[];
              this.categoryListData(id);
              this.hotListData(id);
          }
          this.menusId=id;
        },
        navClickFun(id,type){

          if(this.upDownType && this.navCurId==id){
            this.upDownType=false;
          }else if(!this.upDownType && this.navCurId==id){
            this.upDownType=true;
          }else{
            this.articleListData(id);
          }
          this.navCurId=id;
          this.hotCurId=0;
          this.hotType=type;
        },
        hotClickFun(id,type,uDtype){
          if(this.upDownType && this.hotCurId==id){
            this.upDownType=false;
          }else if(!this.upDownType && this.hotCurId==id){
            this.upDownType=true;
          }else{
            this.hotListData(id);
          }
          this.navCurId=0;
          this.hotCurId=id;
          this.hotType=type;
        },
        detailClick(id,type){
          this.$router.push({
            params: this.$merge(this.$route.params, { id:id }),
          });
          this.$router.push({
            query: this.$merge(this.$route.query, { type, type })
          });
          if(type==2){
            this.secondCategory="热门问题";
          }else{
            this.secondCategory=this.listData.secondCategory.name;
          }

          this.newDetailData(id);
          this.$route.params.id=id;
        },
        newDetailData(id){
          this.hotType=this.$route.query.type;
          getArticleDetail({
              id:id
            }).then(res => {
                let _D = res;
                if(_D.code == 22000){
                  this.rightType=false;
                  this.listData=_D.result;
                  this.menusId=this.listData.firstCategory.id;

                  document.title = this.listData.firstCategory.name+"-"+this.listData.secondCategory.name+'-详情';

                  this.firstCategory=this.listData.firstCategory.name;
                  if(this.detailType==true){//判断是否是刷新路由 0是
                      this.detailType=false;
                      this.menusData(0);
                      this.navCurId=this.listData.secondCategory.id;
                      this.menusClickFun(this.menusId);
                      this.articleListData(this.listData.secondCategory.id);
                      if(this.hotType==2){
                        this.hotListData(this.listData.firstCategory.id);
                      }
                  }
                   if(this.hotType==2){
                    this.secondCategory="热门问题";
                  }else{
                    this.secondCategory=this.listData.secondCategory.name;
                  }
                }else if(_D.code == 23003){
                  this.listData={};
                  this.rightType=true;
                }
            })
        },
        oldDetailData(id){
          this.hotType=this.$route.query.type;
          getArticleOldDetail({
              id:id
            }).then(res => {
                let _D = res;
                if(_D.code == 22000){
                  this.rightType=false;
                  this.listData=_D.result;
                  this.menusId=this.listData.firstCategory.id;
                  document.title = this.listData.firstCategory.name+"-"+this.listData.secondCategory.name+'-详情';
                  this.firstCategory=this.listData.firstCategory.name;
                  if(this.detailType==true){ //判断是否是刷新路由
                      this.detailType=false;
                      this.menusData(0);
                      this.navCurId=this.listData.secondCategory.id;
                      this.menusClickFun(this.menusId);
                      this.articleListData(this.listData.secondCategory.id);
                      if(this.hotType==2){
                        this.hotListData(this.listData.firstCategory.id);
                      }
                  }
                   if(this.hotType==2){
                    this.secondCategory="热门问题";
                  }else{
                    this.secondCategory=this.listData.secondCategory.name;
                  }
                }else if(_D.code == 23003){
                  this.listData={};
                  this.rightType=true;
                }
            })
        }

    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .d_main{
    min-width: 1200px;
    margin:0 auto;
    min-height: 600px;
    overflow: hidden;
    position: relative;
    z-index: 3;
  }
  .d_main_s::before{
    content: "";
    width: 1px;
    position:absolute;
    top:0px;
    bottom:0px;
    left:320px;
    background-color: #F4F4F5;
  }
  .d_main_left{
    float: left;
    padding-top:24px;
    width:300px;
    padding-left:20px;
    overflow: hidden;
    min-height: 600px;
    .d_nav_title{
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #202428;
        letter-spacing: 0;
        text-align: justify;
        line-height: 24px;
        position: relative;
        font-weight: inherit;
        cursor: pointer;
        margin-bottom:24px;
        z-index: 4;
    }
    .d_unfold{
        margin:-16px 0 15px;
    }
    .d_nav_title{
        span{
          display: block;
          width: 20px;
          height: 20px;
          position: absolute;
          right:22px;
          top:0px;
          -webkit-transform: rotate(0);
          transform: rotate(0);
          -ms-transform: rotate(0);
          -webkit-transition: all .3s;
          transition: all .3s;
        }
        span.up{
          background: url("./../assets/icon-shouqi1.png") no-repeat 2px 2px;
          background-size: 16px 16px;
        }
        span.down{
          -webkit-transform: rotate(-180deg);
          transform: rotate(-180deg);
          -ms-transform: rotate(-180deg);
        }
    }
    .d_nav_title.cur{
          color:#006EFB;
          span.up{
            background: url("./../assets/icon-shouqi2.png") no-repeat 2px 2px;
          background-size: 16px 16px;
          }
          span.down{
            // background: url("./../assets/icon-shouqi2.png") no-repeat 2px 2px;
          background-size: 16px 16px;
          -webkit-transform: rotate(-180deg);
          transform: rotate(-180deg);
          -ms-transform: rotate(-180deg);
        }
    }
    .d_hot{
        span{
          display: block;
          width: 20px;
          height: 20px;
          position: absolute;
          right:22px;
          top:8px;
           -webkit-transform: rotate(0);
          transform: rotate(0);
          -ms-transform: rotate(0);
          -webkit-transition: all .3s;
          transition: all .3s;
        }
        span.up{
          background: url("./../assets/icon-shouqi1.png") no-repeat 2px 2px;
          background-size: 16px 16px;
        }
        span.down{

          -webkit-transform: rotate(-180deg);
          transform: rotate(-180deg);
          -ms-transform: rotate(-180deg);
        }
    }
    .d_nav_title span{
        top:2px;
    }
    .d_hot{
        font-family: PingFangSC-Regular;
        font-size: 13px;
         font-weight: inherit;
        color: #202428;
        letter-spacing: 0;
        text-align: justify;
        line-height: 36px;
        height:36px;
        padding-left:20px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        cursor: pointer;
        position: relative;
        z-index: 4;
    }
    .d_hot_list{
        li{
            line-height: 36px;
            height:36px;
            padding:0 24px 0 20px;
            font-family: PingFangSC-Light;
            font-size: 13px;
            color: #7E8082;
            letter-spacing: 0;
            position: relative;
            margin-bottom:2px;
            cursor: pointer;
            span{
              overflow: hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
              display: block;
              line-height: 36px;
              height:36px;
              width: 256px;
              font-family: PingFangSC-Light;
              font-size: 13px;
              color: #7E8082;
            }
            div{
              display: none;
              background: #FFFFFF;
              box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
              border: 1px solid rgba(228, 228, 229, 1);
              padding:8px 10px;
              width: 235px;
              font-family: PingFangSC-Regular;
              font-size: 12px;
              color: #595959;
              text-align: justify;
              line-height: 20px;
              position:absolute;
              bottom:44px;
              left:50%;
              margin-left:-127px;
              z-index: 666;
              em{
                display: none;
                content: "";
                position:absolute;
                bottom:-5px;
                left:40px;
                width:9px;
                height:5px;
                z-index: 6666;
                background: url("./../assets/icon-sanjiao.png") no-repeat 0 0;
                background-size: 9px 5px;
              }
            }
        }
        li.cur,li:hover{
            position: relative;
            z-index: 4;
            background: #ebf4ff;
            font-family: PingFangSC-Light;
            font-size: 13px;
            color: #3f8cfc;
            letter-spacing: 0;
            text-align: justify;
        }
        li.cur span{
          font-size: 13px;
            color: #3f8cfc;
        }
        li.cur::after{
            content: "";
            position:absolute;
            top:0px;
            right:0px;
            height:36px;
            width: 2px;
            z-index: 2;
            background: #006EFB;
        }

        li:hover em ,li:hover div{
          display: block;
        }
    }
  }
  .d_no_list{
        width:1200px;
        margin:0px auto 0px;
        min-height:600px;
        text-align: center;
        img{
            width: 174px;
            height: 199px;
            margin:114px 0 40px;
        }
        p{
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #515457;
            letter-spacing: 0;
            text-align: center;
            line-height: 26px;
        }

    }
  .d_main_right{
    margin-left:320px;
    padding:24px 40px 0 40px;
    min-height: 600px;
    border-left:1px solid #E4E7ED;
    .d_bread{
        font-family: PingFangSC-Regular;
        font-size: 13px;
        color: #515457;
        letter-spacing: 0;
        line-height: 20px;
        height:20px;
        margin-bottom:24px;
        width: 100%;
        text-overflow:ellipsis;
        white-space:nowrap;
        overflow: hidden;
        a,span,em{
            float: left;
            font-size: 13px;
            color: #515457;
        }
        a{
            cursor: pointer;
        }
        a:hover{
            color:#006EFB
        }
        em{
            margin:0 4px;
            font-style: normal;
        }
        .bread_title{
            text-overflow:ellipsis;
            white-space:nowrap;
            overflow: hidden;
            width: 600px;
        }
    }
    .d_article_title{
        padding-bottom:24px;
        border-bottom:#E4E7ED 1px solid;
        h3{
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #202428;
            text-align: left;
            line-height: 32px;
            margin-bottom: 16px;
        }
        p{
            font-family: PingFangSC-Regular;
            font-size: 13px;
            color: #7E8082;
            text-align: left;
            line-height: 20px;
        }
    }
    .d_article_main{
        margin-top:40px;
        .d_article{
          width: 700px;
          height: 350px;
          margin: 0 0 30px;
        }
        .d_comment_info{
          padding-bottom:60px;
        }
        h1{
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #202428;
            text-align: left;
            line-height: 28px;
            margin-bottom:20px;
        }
        h4,strong,h2,h3{
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #202428;
            text-align: left;
            line-height: 22px;
             margin-bottom:20px;
        }
        p{
            font-family: PingFangSC-Light;
            font-size: 13px;
            color: #515457;
            text-align: left;
            line-height: 20px;
            margin-bottom: 16px;
        }
        img{
          width: 600px;
          display: block;
          margin-bottom:40px;
        }
        table{
          border-collapse: collapse;
          text-align: left;
          width: 100%;
          td{
                border:1px solid  #000!important;
                padding: 2px;
                background-color: initial !important;
                h2{
                  margin-bottom:0;
                }
          }
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/hc/articles.vue